"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styles = require("@material-ui/core/styles");

var _constants = require("../constants");

const CircularPro = {
  fontFamily: 'Circular Pro',
  fontStyle: 'normal',
  fontDisplay: 'swap',
  fontWeight: 400,
  unicodeRange: 'U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF'
};
const sortedTheme = (0, _styles.createMuiTheme)({
  breakpoints: {
    values: {
      xs: 0,
      sm: parseInt(_constants.breakpoints.mobile, 10),
      md: parseInt(_constants.breakpoints.tablet, 10),
      lg: parseInt(_constants.breakpoints.desktop, 10),
      xl: 1920
    }
  },
  palette: {
    primary: {
      light: _constants.colours.red,
      main: _constants.colours.pink,
      dark: _constants.colours.pinkActive
    },
    secondary: {
      light: _constants.colours.red,
      main: _constants.colours.font,
      dark: _constants.colours.buttonBackgroundActive
    },
    text: {
      primary: _constants.colours.font,
      main: _constants.colours.primary
    }
  },
  typography: {
    fontFamily: [CircularPro.fontFamily, '-apple-system', 'BlinkMacSystemFont', '"Segoe UI"', 'Roboto', '"Helvetica Neue"', 'Arial', 'sans-serif', '"Apple Color Emoji"'].join(','),
    button: {
      textTransform: 'none'
    }
  },
  overrides: {
    MuiCssBaseline: {
      '@global': {
        '@font-face': [CircularPro]
      }
    },
    MuiPaper: {
      rounded: {
        borderRadius: '10px'
      }
    },
    MuiCard: {
      root: {
        maxWidth: 501,
        backgroundColor: _constants.colours.cardTop,
        border: 'none',
        height: 'auto',
        boxShadow: '0 0 30px 0 rgba(0, 0, 0, 0.15)'
      }
    },
    MuiCardActions: {
      root: {
        backgroundColor: '#fff'
      }
    },
    MuiCardContent: {
      root: {
        minHeight: 200,
        backgroundColor: 'inherit'
      }
    },
    MuiButton: {
      root: {
        boxShadow: 'none',
        textAlign: 'center',
        '&:disabled': {
          cursor: 'default'
        },
        '&:hover': {
          boxShadow: 'none'
        },
        '&:active': {
          boxShadow: 'none'
        }
      },
      contained: {
        boxShadow: 'none',
        '&:hover': {
          boxShadow: 'none'
        },
        '&:active': {
          boxShadow: 'none'
        }
      }
    },
    MuiSelect: {
      root: {
        paddingTop: 12,
        paddingBottom: 12
      },
      icon: {
        borderLeft: `1px solid ${_constants.colours.inputBorder}`,
        borderRight: 'none',
        top: 0,
        height: '100%'
      },
      iconOutlined: {
        padding: '0 8px',
        right: 0
      },
      iconOpen: {
        borderLeft: 'none',
        borderRight: `1px solid ${_constants.colours.inputBorder}`,
        fill: _constants.colours.primary
      },
      select: {
        '&:focus': {
          backgroundColor: 'none'
        }
      }
    },
    MuiAutocomplete: {
      endAdornment: {
        top: '0',
        right: '3px !important',
        position: 'absolute',
        bottom: '0'
      },
      clearIndicator: {
        height: '100%',
        width: '40px',
        borderRadius: '0'
      },
      inputRoot: {
        '&:focus': {
          borderColor: _constants.colours.blue
        }
      },
      formLabel: {
        root: {
          '&:focus': {
            color: `${_constants.colours.font} !important`
          }
        }
      },
      popupIndicator: {
        width: '40px',
        height: '100%',
        borderRadius: '0',
        borderLeft: `1px solid ${_constants.colours.inputBorder}`
      },
      paper: {
        borderRadius: 4
      }
    },
    MuiTooltip: {
      tooltip: {
        backgroundColor: _constants.colours.tooltipBg
      },
      arrow: {
        color: _constants.colours.tooltipBg
      }
    },
    MuiOutlinedInput: {
      root: {
        borderRadius: 6,
        borderColor: _constants.colours.inputBorder,
        '&$focused $notchedOutline': {
          borderColor: _constants.colours.inputFocus,
          borderWidth: 1
        }
      }
    },
    MuiInputLabel: {
      root: {
        color: _constants.colours.font,
        fontFamily: _constants.fonts.bold
      },
      asterisk: {
        color: _constants.colours.primary
      }
    }
  }
});
var _default = sortedTheme;
exports.default = _default;